import { useState } from 'react';

import { useUnit } from 'effector-react';
import { useHistory } from 'react-router-dom';

import ExternalWindow from '@m/assets/svg/external-window';
import BottomSheet from '@m/components-ui/bottom-sheet';
import { SubpageHeader } from '@m/components-ui/subpage-header';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@m/constants/Contacts';
import { showAlert } from '@m/state/alert';
import UserService from 'apps/customer/services/UserService';
import { userStore } from 'apps/customer/state/user';

import {
  Box,
  ContentBox,
  ExternalLink,
  DeleteButton,
  DeleteSection,
  BsText,
  BsControls,
  BsCancelButton,
  BsDeleteButton,
} from './AccountDeletePage.styled';

export default function AccountDeletePage() {
  const history = useHistory();
  const { user } = useUnit(userStore);

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);

  const deleteAccount = () => {
    if (user.id) {
      UserService.deleteAccount(user.id).then((res) => {
        if (res.success) {
          window.location.reload();
        } else {
          showAlert({
            label: 'There was an error deleting your account.',
            type: 'error',
          });

          setDeleteInProgress(false);
        }
      });
    }
  };

  const handleDeleteClick = () => {
    setDeleteInProgress(true);
    deleteAccount();
  };

  return (
    <Box>
      <SubpageHeader onBackClick={() => history.goBack()} title="Terms and Privacy" />
      <ContentBox>
        <ExternalLink
          href={TERMS_OF_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Terms of Service (opens in a new tab)"
        >
          Terms of Service <ExternalWindow aria-hidden="true" focusable="false" />
        </ExternalLink>
        <ExternalLink
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Privacy Policy (opens in a new tab)"
        >
          Privacy Policy <ExternalWindow aria-hidden="true" focusable="false" />
        </ExternalLink>
        <ExternalLink
          href={`${PRIVACY_POLICY_URL}#california-privacy-notice`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="California Privacy Notice (opens in a new tab)"
        >
          California Privacy Notice <ExternalWindow aria-hidden="true" focusable="false" />
        </ExternalLink>
        <ExternalLink
          href="https://www.metropolis.io/do-not-sell"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Do not Sell (opens in a new tab)"
        >
          Do not Sell <ExternalWindow aria-hidden="true" focusable="false" />
        </ExternalLink>
      </ContentBox>
      <DeleteSection>
        <DeleteButton onClick={() => setShowDeleteConfirmation(true)}>Delete account</DeleteButton>
      </DeleteSection>
      <BottomSheet
        open={showDeleteConfirmation}
        onDismiss={() => setShowDeleteConfirmation(false)}
        dismissible={!deleteInProgress}
        title="Are you sure you want to delete your account?"
        showHandle
      >
        <BsText>
          If you delete your account, you will not be able to pay for parking at Metropolis-powered
          locations.
        </BsText>
        <BsText>
          This will also result in you losing access to all history and payment methods associated
          with your account.
        </BsText>
        <BsControls>
          <BsCancelButton
            disabled={deleteInProgress}
            deleting={deleteInProgress}
            onClick={() => setShowDeleteConfirmation(false)}
          >
            Cancel
          </BsCancelButton>
          <BsDeleteButton
            disabled={deleteInProgress}
            deleting={deleteInProgress}
            onClick={handleDeleteClick}
          >
            {deleteInProgress ? 'Deleting...' : 'Delete'}
          </BsDeleteButton>
        </BsControls>
      </BottomSheet>
    </Box>
  );
}
